import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DashboardComponent]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// /workspace/chess.arska.org/chess/src/app/dashboard/dashboard.module.ts